import { render, staticRenderFns } from "./sampleBorrwing.vue?vue&type=template&id=ebe4b4be&scoped=true&"
import script from "./sampleBorrwing.vue?vue&type=script&lang=js&"
export * from "./sampleBorrwing.vue?vue&type=script&lang=js&"
import style0 from "./sampleBorrwing.vue?vue&type=style&index=0&id=ebe4b4be&lang=scss&scoped=true&"
import style1 from "./sampleBorrwing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe4b4be",
  null
  
)

export default component.exports